import axiosInstance from "../../../../api/axiosConfig";
import { handleAPIError } from "../../../../api/utils/errors";
import type { CompatMigrationResult } from "../types";

const call = async <T>(operation: () => Promise<{ data: T }>): Promise<T> => {
  try {
    const response = await operation();
    return response.data;
  } catch (error) {
    const apiError = handleAPIError(error);
    throw apiError;
  }
};

/** `/api/compat/...`: the on-demand legacy compatibility migration. */
export const CompatAPI = {
  /**
   * Run whatever is left of the case's migration. The server answers 200 with
   * a status whatever happened; only transport failures reject.
   */
  migrate(individualId: string) {
    return call<CompatMigrationResult>(() =>
      axiosInstance.post(`/compat/${individualId}/migrate`, {})
    );
  }
};
